<!-- 解决方案分类 -->
<template>
    <div class="solution-classify-container">
      <!-- 顶部搜索组件 -->
      <roof-search :middleContent="false" :rightContent="false" v-if="showNav"></roof-search>
      <div class="classify-list" ref="activity_scroll" @scroll="activityScroll">
        <div class="item" @click="goList(item)" v-for="(item,index) in classifyList" :key="index">
          <div class="cover-img">
            <img :src="cdnUrl+item.img_url" alt="" class="img">
          </div>
          <div class="bottom-content">
            <div class="left-content">
              <div class="classify">{{item.title || ''}}</div>
              <div class="introduce van-multi-ellipsis--l2">{{item.desc}}</div>
            </div>
            <div class="right-icon">
              <i class="iconfont icon-youjiantou"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { wxShare } from '@/libs/wxjssdk'
import { getSolutionTypeList } from '@/api/solution'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            showNav: true,
            classifyList: []
        }
    },
    components: {
        roofSearch
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    activated () {
        this.showNav = true
        this.sharePage()
    },
    deactivated () {
        this.showNav = false
    },
    created () {
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        this.getSolutionTypeListPort()
        // this.$toast(
        //   {
        //     message: '该功能正在开发中，敬请期待',
        //     duration: 3000
        //   }
        // )
    },
    mounted () {

    },
    methods: {
        sharePage () {
            const params = {
                title: 'Eppendorf 应用解决方案', // 分享标题
                desc: 'Eppendorf 应用解决方案', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        activityScroll () {
        // var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
        // var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
        // var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
        // if (scrollHeight - scrollTop <= clientHeight) {
        //   // if (this.pageSize < this.last_page) {
        //   //   this.pageSize++
        //   //   this.getExampleListPort()
        //   // }
        //   // this.$toast('上拉触底了')
        // }
        },
        goList (item) {
            this.$router.push(
                {
                    name: 'solutionList',
                    query: {
                        id: item.id || '',
                        title: item.title
                    }
                }
            )
        },
        /** 网络请求 **/
        // 获取解决方案类型列表
        getSolutionTypeListPort () {
            getSolutionTypeList().then(res => {
                this.$toast.clear()
                if (res.errCode === 0) {
                    var data = res.data
                    this.classifyList = data
                    // console.log(data)
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                console.log('获取解决方案类型列表失败', err)
                this.$toast('获取解决方案类型接口出错，请稍后重试')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.solution-classify-container{
  background: #F5F3F9;
  height: 100vh;
  .classify-list{
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: rem(46) 0;
    .item{
      width: 90%;
      height: rem(220);
      margin: 0 auto;
      background: #fff;
      margin-top: rem(20);
      border-radius: 4px;
      .cover-img{
        height: rem(138);
        overflow: hidden;
        .img{
          width: 100%;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
      }
      .bottom-content{
        height: rem(80);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 rem(17);
        .left-content{
          width: 90%;
          .classify{
            font-size: rem(15);
            color: #2C2C2C;
            font-weight: bold;
            margin-bottom: rem(8);
          }
          .introduce{
            color: #2C2C2C;
            font-size: rem(12);
          }
        }
        .right-icon{
          color: #9D9D9D;
          .iconfont{
            font-size: rem(20);
          }
        }
      }
    }
  }
}
</style>
